// PATH: src/components/PageHeader.tsx — en-tête commun aux pages.
//
// Sépare les trois rôles que l'ancien bandeau mélangeait sur une seule ligne :
// le titre (où suis-je), les filtres (ce que je regarde) et l'action principale
// (ce que je peux faire). Une page = une seule action primaire, à droite.
import React from "react";
import { Space, Typography } from "antd";

const PageHeader: React.FC<{
  title: string;
  subtitle?: React.ReactNode;
  /** Filtres et sélecteurs — alignés à droite, avant l'action primaire. */
  filters?: React.ReactNode;
  /** Action primaire de la page (une seule). */
  action?: React.ReactNode;
}> = ({ title, subtitle, filters, action }) => (
  // La classe porte l'empilement sur écran étroit (index.css) : sous 576px le
  // titre prend une ligne, filtres et action la suivante sur toute la largeur.
  <div
    className="page-header"
    style={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 16,
      marginBottom: 20,
    }}
  >
    <div style={{ minWidth: 0 }}>
      <Typography.Title level={3} style={{ margin: 0, fontWeight: 600, letterSpacing: "-0.01em" }}>
        {title}
      </Typography.Title>
      {subtitle && (
        <Typography.Text type="secondary" style={{ fontSize: 13 }}>
          {subtitle}
        </Typography.Text>
      )}
    </div>
    <Space wrap size={8}>
      {filters}
      {action}
    </Space>
  </div>
);

export default PageHeader;
